import FAQModal from './FAQ-modal.vue'
export default FAQModal
